import { useMutation } from '@tanstack/react-query'
import { useIndexesContext } from '~/contexts/IndexesContext'
import { useWorkspaceContext } from '~/contexts/WorkspaceContext'
import { deleteConnection } from '~/services/organizationService'
import { queryClient, QueryKeys } from '~/services/queryClient'

export function useDeleteConnection() {
  const { currentWorkspace } = useWorkspaceContext()
  const { refetch } = useIndexesContext()

  return useMutation({
    mutationFn: (conn_type: string) => {
      if (!currentWorkspace?.uuid) {
        throw new Error('Workspace UUID not available')
      }
      return deleteConnection(conn_type, currentWorkspace.uuid)
    },
    async onSuccess() {
      // Invalidate both connection metadata and status after successful deletion
      queryClient.invalidateQueries({ queryKey: [QueryKeys.ConnectionMetadata] })
      queryClient.invalidateQueries({ queryKey: [QueryKeys.ConnectionStatus] })
      refetch()
    }
  })
}
